import { isAxiosError } from "axios";
import { axios } from "../../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";
import { useGeneralAppStore } from "../../store/generalAppStore";

const { handlerLoading } = useGeneralAppStore.getState();

export const reenviarEmail = async (payload, setError) => {
  handlerLoading({ loading: true, loadName: "reenviar-email" });
  try {
    const response = await axios().post("reenviar_email_rifas", payload);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        data.map((mensaje) => {
          toast.success(mensaje.data, toastOptions);
          if (mensaje.error) {
            setError("email", { type: "custom", message: `${mensaje.error}, comuníquese con el 147` });
            // setError("email", { type: "custom", message: mensaje.error });
            toast.error(mensaje.error, toastOptions);
          }
        });
      }
      if (!data && error) {
        toast.error(error, toastOptions);

        console.log(error);
      }
    }
  } catch (error) {
    toast.error(error, toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "reenviar-email" });
  }
};
